// extracted by mini-css-extract-plugin
export default {"root":"CloseButton_root__UWnDS","icon":"CloseButton_icon__iWuZP"};